import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    // 로딩이 한 번 이라도 됐는지 판단
    loaded: false,
    bookmarkedList: [],
};

const { actions, reducer } = createSlice({
    name: 'bookmarkedItem',
    initialState,
    reducers: {
        setBookmarkedList: (state, action) => {
            state.loaded = true;
            state.bookmarkedList = action.payload;
        },
    },
});

export const { setBookmarkedList } = actions;
export default reducer;
